import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormLabel } from '@material-ui/core';
import { CheckIcon } from '../Icons';

const StyledCheckbox = ({ classes, value, label, checked, icon, onChange }) => {
  const Icon = icon;
  return (
    <FormLabel className={classes.label}>
      {icon && (
        <div className={classes.iconContainer}>
          <Icon className={classes.icon} />
        </div>
      )}
      {label}
      <Checkbox
        className={classes.checkbox}
        value={value}
        icon={<span />}
        data-testid={`styled-checkbox-${value}`}
        checkedIcon={<CheckIcon className={classes.checkedIcon} />}
        onChange={onChange}
        checked={checked}
      />
    </FormLabel>
  );
};

StyledCheckbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.string,
  label: PropTypes.node,
  checked: PropTypes.bool,
};

StyledCheckbox.defaultProps = {
  classes: {},
  value: '',
  label: null,
  checked: false,
};

export default StyledCheckbox;
